import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { urlServer } from '../global_constants';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class VisitsService {

  constructor(private httpClient:HttpClient) { 
    this.visitSubject=new Subject();
    this.visitToSaleSubject =new Subject();
    this.archivedVisitsSubject = new Subject();
    this.refusedVisitsSubject = new Subject();
    this.actionsSubject=new Subject();
    this.timeSubject= new Subject();
    this.planifierSubject= new Subject();
    this.advancedSearchSubject = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
      this.deplacementSubject=new Subject();
  }
  //visits variables
  pathApiVisit:string="/v1/visits";
  visitSubject:Subject<any>;
  visitToSaleSubject:Subject<any>;
  userRequest:any;
  urlRequestVisit: string =urlServer.concat(this.pathApiVisit);
  token:any;
  //Archived visits variables
  pathApiArchivedVisits:string="/v1/visits/archived";
  pathApiRefusedVisits:string="/v1/visits/refused";
  archivedVisitsSubject:Subject<any>;
  refusedVisitsSubject:Subject<any>;
  urlRequestArchivedVisits: string =urlServer.concat(this.pathApiArchivedVisits);
  urlRequestRefusedVisits: string =urlServer.concat(this.pathApiRefusedVisits);

  //actions variables
  pathApiActions:string="/v1/actions/";
  actionsSubject:Subject<any>;
  actionsRequest:any;
  urlRequestActions: string =urlServer.concat(this.pathApiActions);
  //deplacement variables
  pathApiDeplacement:string="/v1/indicators/visits";
  deplacementSubject:Subject<any>;
  deplacementRequest:any;
  urlRequestDeplacement: string =urlServer.concat(this.pathApiDeplacement);

  //Time variables
  pathApiTime:string="/v1/commercial/";
  // pathApiTime1:string="/occupiedSlots";
  timeSubject:Subject<any>;
  timeRequest:any;
  urlRequestTime: string =urlServer.concat(this.pathApiTime);

  //planifier variables
  pathApiPlanifier:string="/v1/visit/";
  planifierSubject:Subject<any>;
  planifierRequest:any;
  urlRequestPlanifier: string =urlServer.concat(this.pathApiPlanifier);

  //advanced search actions
  pathApiAdvSearchActions:string="/v1/actions/advanced";
  advancedSearchSubject:Subject<any>;
  advancedSearchRequest:any;
  urlRequestAdvSearchActions: string =urlServer.concat(this.pathApiAdvSearchActions);

  //Retrieve cover visits statistics
  pathApiStatiscticsCover:string="/v1/visits/cover/commercial/";
  urlRequestStatiscticsCover: string =urlServer.concat(this.pathApiStatiscticsCover);
  
  getVisit(){
    this.visitSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestVisit,{headers: header}).subscribe((response: any) => {
      this.visitSubject.next(response);
      this.visitSubject.complete();
    },)
  }
  
  getArchivedVisits(){
    this.archivedVisitsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestArchivedVisits,{headers: header}).subscribe((response: any) => {
      this.archivedVisitsSubject.next(response);
      this.archivedVisitsSubject.complete();
    },)
  }

  getRefusedVisits(){
    this.refusedVisitsSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestRefusedVisits,{headers: header}).subscribe((response: any) => {
      this.refusedVisitsSubject.next(response);
      this.refusedVisitsSubject.complete();
    },)
  }
  

 getActions(type:any){
  this.actionsSubject = new Subject();
  let header: HttpHeaders = new HttpHeaders();
   header = header.set('authorization', "Bearer "+this.token );
   this.httpClient.get(this.urlRequestActions+type,{headers: header}).subscribe((response: any) => {
     this.actionsSubject.next(response);
     this.actionsSubject.complete();
    },)
  }

 getDeplacement(){
  this.deplacementSubject = new Subject();
  let header: HttpHeaders = new HttpHeaders();
   header = header.set('authorization', "Bearer "+this.token );
   this.httpClient.get(this.urlRequestDeplacement,{headers: header}).subscribe((response: any) => {
     this.deplacementSubject.next(response);
     this.deplacementSubject.complete();
},)
}
  getTime(id:any){
    this.timeSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestTime+id+"/occupiedSlots",{headers: header}).subscribe((response: any) => {
      this.timeSubject.next(response);
      this.timeSubject.complete();
    },)
  }
  getPlanifier(visit_id:any) {
    this.planifierSubject = new Subject();
    const body = {
      planned_date: this.planifierRequest.planned_date,
    };
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.put(this.urlRequestPlanifier+visit_id,body,{headers: header}).subscribe(
      (response: any) => {
        this.planifierSubject.next(response);
        this.planifierSubject.complete();
      },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
  advancedSearchActions(){
    this.advancedSearchSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.post(this.urlRequestAdvSearchActions,this.advancedSearchRequest,{headers: header}).subscribe((response: any) => {
      this.advancedSearchSubject.next(response);
      this.advancedSearchSubject.complete();
    },)
  }
  getVisitsStatisticsCover(commercial:any): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<ServiceResponse>(this.urlRequestStatiscticsCover+commercial,{headers: header});
  }

  getVisitToSale(id:any){
    this.visitToSaleSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    this.httpClient.get(this.urlRequestPlanifier+id+"/forSale",{headers: header}).subscribe((response: any) => {
      this.visitToSaleSubject.next(response);
      this.visitToSaleSubject.complete();
    },)
  }

  updateVisitDescription(uuidVisit:any, description:any): Observable<ServiceResponse>{
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return this.httpClient.patch<ServiceResponse>(this.urlRequestPlanifier+uuidVisit+"/description",
      { description: description },{headers: header});
  }
}

